<template>
  <svg :class="$style.icon" ref="icon">
    <use v-bind="{ 'xlink:href' : `#${id}` }" />
  </svg>
</template>

<script>
export default {
  props: ['id']
}
</script>

<style module lang="scss">
.icon {
  fill: $color-ui;
  width: 14px;
  height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue